<header
  class="rds-padding-inline-150 rds-display-flex rds-justify-content-between rds-align-items-center rds-section-color-background">
  <div
    class="rds-display-flex rds-justify-content-between rds-align-items-center">
    <div>
      <h2
        class="rds-heading-2 rds-margin-block-end-0 rds-margin-inline-end-200 logo top-logo">
        Rabo
      </h2>
      <h2
        class="rds-heading-2 logo rds-margin-block-end-0 rds-margin-inline-end-200">
        Value Chain Viewer
      </h2>
    </div>
    <rds-tab-group [attr.active-tab]="activeTab" class="tab-group">
      @if (isBankerIQEnabled) {
        @if (isBankerIQUser) {
          <rds-tab tab-name="BankerIQ" (rdsTabClick)="goToBankerIQModule()"
            >BankerIQ</rds-tab
          >
        }
      }
      @if (isValueChainViewerUser) {
        <rds-tab tab-name="Viewer" (rdsTabClick)="goToVcvModule()"
          >Viewer</rds-tab
        >
      }
      @if (isBusinessInputUser) {
        <rds-tab
          tab-name="Business Input"
          (rdsTabClick)="goToBusinessInputModule()"
          >Business Input</rds-tab
        >
      }
    </rds-tab-group>
  </div>
  @if (isLoggedIn) {
    <span>
      <rds-button
        class="rds-display-inline-block rds-margin-inline-end-150"
        variant="tertiary-default"
        ><rds-icon name="rds-icon-person" size="sm" variant="default"></rds-icon
        >{{ userName }}</rds-button
      >
      <rds-button
        class="rds-display-inline-block"
        variant="tertiary-default"
        (rdsClick)="onLogout()"
        ><rds-icon name="rds-icon-power" size="sm" variant="default"></rds-icon
        >Logout</rds-button
      >
    </span>
  } @else {
    <rds-button
      class="rds-display-inline-block"
      variant="tertiary-default"
      (rdsClick)="onLogin()"
      ><rds-icon
        name="rds-icon-padlock-closed"
        size="sm"
        variant="default"></rds-icon
      >Login</rds-button
    >
  }
</header>
<hr class="rds-divider-inline" />
